import PaymentSource, { ModelType } from "./model";
import normalizedActions from "../utils/normalized/actions";

export function addPaymentSourceFromNormalizedData(data, associations) {
  return (dispatch) => {
    let paymentSource = new PaymentSource();
    paymentSource.deserialize(data, associations);
    dispatch(addPaymentSource(paymentSource));
  };
}

export function addPaymentSource(data, associations) {
  return (dispatch, getState) => {
    return normalizedActions.updateOrCreateModel(
      dispatch,
      getState().paymentSources,
      ModelType,
      data,
      associations,
    );
  };
}
